angular
  .module("myApp")
  .controller("BaseEditController", function ($scope, $state, $stateParams, uuiData, Notification) {
    $scope.dto = void 0
    this.dto_before_edit = {}
    $scope.editMode = false
    $scope.edit = {} // alternatīvā editMode implementācija: [tab]: true/false
    $scope.dto_view = "something_editable"
    let edit_after_reload = false

    $scope.afterLoad = () => true
    $scope.beforeSave = () => true

    this.save_backup = () => {
      _.each($scope.dto, (v, k) => {
        this.dto_before_edit[k] = v
        // sic: references paliek, tā ka ja kāds edits mutē apakšobjektus, tad to nevarēs atcelt
      })
    }

    $scope.save_backup = this.save_backup

    $scope.reload = (params) => {
      if (params === void 0) {
        params = {}
      }
      const n = uuiData.record($scope.dto_view, $stateParams.id)
      if ($scope.dto === undefined) $scope.dto = n

      n.$promise.catch((e) => {
        Notification.error(e.data)
        n.failed = true
        n.exception = e.data
      })

      n.$promise.then(() => {
        n.failed = false
        if (params.handler) {
          params.handler(n)
        } else {
          _.each(n, (v, k) => {
            $scope.dto[k] = v
          })
        }
        const ed = $scope.edit
        try {
          $scope.afterLoad()
        } catch (e) {
          console.error(e)
          Notification.error(
            `Notika kļūda: lūdzu, dodiet mums par to ziņu, norādot saiti, kurā šis notika?<br><br>
             ${e.toString()}`
          )
        }
        $scope.ready = true
        this.save_backup()
        if (edit_after_reload) {
          $scope.setEditMode()
          $scope.edit = ed
          edit_after_reload = false
        } else {
          return $scope.setViewMode()
        }
      })
      return n.$promise
    }

    $scope.save = () => {
      $scope.beforeSave()
      return $scope.dto.$save(
        () => {
          Notification.success("Izmaiņas saglabātas")
          $scope.reload()
          $scope.editMode = false
        },
        (err) => {
          var error_text
          error_text = err.data ? err.data : "Datus saglabāt neizdevās"
          Notification.error(error_text)
        }
      )
    }

    $scope.hasEdits = () => false

    $scope.dbg_changes = () => {
      const out = []
      _.each(this.dto_before_edit, (v, k) => {
        if (v !== $scope.dto[k]) {
          out[k] = {
            old: v,
            new: $scope.dto[k],
          }
        }
      })
      return out
    }

    $scope.undoEdits = () => {
      $scope.setViewMode()
      _.each(this.dto_before_edit, (v, k) => {
        $scope.dto[k] = v
      })
    }

    $scope.setEdit = (tab) => {
      this.save_backup()
      $scope.editMode = true
      $scope.edit = { [tab]: true }
    }

    $scope.setEditMode = () => {
      this.save_backup()
      $scope.editMode = true
    }

    $scope.setViewMode = () => {
      $scope.editMode = false
      $scope.edit = {}
    }

    if ($state.current.name.slice(-4) === "open") {
      edit_after_reload = true
    }
  })
